export default "__VITE_ASSET__PYv8WG5v__"